// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V5C2 7.20914 3.79086 9 6 9C7.19469 9 8.26706 8.47624 9 7.64582C9.73295 8.47624 10.8053 9 12 9C13.1947 9 14.2671 8.47624 15 7.64582C15.7329 8.47624 16.8053 9 18 9C20.2091 9 22 7.20914 22 5V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 22.0004V9.47266C3.06151 10.4227 4.46329 11.0004 6 11.0004C7.09262 11.0004 8.11773 10.7075 9 10.1973C9.88227 10.7075 10.9074 11.0004 12 11.0004C13.0926 11.0004 14.1177 10.7075 15 10.1973C15.8823 10.7075 16.9074 11.0004 18 11.0004C19.5367 11.0004 20.9385 10.4227 22 9.47266V22.0004H16.5V14.0005H7.5V22.0004H2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.5 16.0005V22.0005H14.5V16.0005H9.5Z"}}]};

const Shop1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'shop-1-filled',
    ref,
    icon: element,
  },
));

Shop1FilledIcon.displayName = 'Shop1FilledIcon';

export default Shop1FilledIcon;
